import { Injectable } from "@angular/core";
import { AlulaDatabaseService, AlulaResponseData } from "@app/shared/databases/alula.database";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AlulaReceiver, AlulaReceiverHelper } from "../model/alula-receiver";

@Injectable({
    providedIn: "root",
})
export class AlulaReceiverDbService {
    constructor(private databaseService: AlulaDatabaseService) {}

    getAlulaReceivers() {
        return this.databaseService.getRecords$(AlulaReceiverHelper.dbEndpoint).pipe(
            map((receivers: AlulaResponseData[] = []) => receivers.map(receiver => AlulaReceiverHelper.fromDbObject(receiver))),
            catchError(DataServiceError.handleError())
        );
    }

    getAlulaReceiversByDealerId(dealerId: string) {
        return this.databaseService
            .getRecords$(AlulaReceiverHelper.dbEndpoint, {
                dealerId,
            })
            .pipe(
                map((receivers: AlulaResponseData[] = []) => {
                    const _rec = receivers.map(receiver => AlulaReceiverHelper.fromDbObject(receiver));
                    return { receivers: _rec, dealerId };
                }),
                catchError(DataServiceError.handleError())
            );
    }

    getAlulaReceiverById(id: string) {
        return this.databaseService.getRecord$(AlulaReceiverHelper.dbEndpoint, id);
    }

    createAlulaReceiver(receiver: AlulaReceiver): Observable<AlulaReceiver> {
        return this.databaseService.createRecord$(AlulaReceiverHelper.dbEndpoint, receiver).pipe(
            map((newReceiver: AlulaResponseData) => AlulaReceiverHelper.fromDbObject(newReceiver)),
            catchError(DataServiceError.handleError())
        );
    }

    updateAlulaReceiver(receiver: AlulaReceiver, id: string): Observable<AlulaReceiver> {
        const _receiver = AlulaReceiverHelper.toDbObject(receiver);
        return this.databaseService.updateRecord$(AlulaReceiverHelper.dbEndpoint, _receiver, id).pipe(
            map((alulaReceiver: AlulaResponseData) => AlulaReceiverHelper.fromDbObject(alulaReceiver)),
            catchError(DataServiceError.handleError())
        );
    }

    deleteAlulaReceiver(id: string) {
        return this.databaseService.deleteRecord$(AlulaReceiverHelper.dbEndpoint, id);
    }
}
